function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transition: transform 0.5s ease-out;\n  transform: rotate(0);\n\n  &:hover {\n    transform: rotate(-1turn);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../theme";
import { AppIconStyle } from "./AppIcon.styles";
export var SettingsIconStyle = styled(AppIconStyle)(_templateObject());